import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiUrlV1 } from "../../../config/config";
import { agent } from "../../../api";
import { addNotification } from "../../Notification/notificateStore";
import { IWheelEntity, WheelEntityRequest } from "../../../entities/wheelGame";

const DEFAULT_URL_V2 = `${apiUrlV1}/v2/organization/game/fortunewheel/`;

export const postWheelEntity = createAsyncThunk(
  "wheel/post-wheel-entity",
  async (
    params: { data: WheelEntityRequest },
    thunkApi
  ): Promise<IWheelEntity | undefined> => {
    try {
      const response = await agent.post(`${DEFAULT_URL_V2}prize`, {
        body: JSON.stringify(params.data),
      });

      if (response.ok) {
        thunkApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        const result = (await response.json()) as IWheelEntity;
        return result;
      }
      if (!response.ok) {
        const result = (await response.json()) as { message: string };
        thunkApi.dispatch(
          addNotification({ status: "error", text: result.message })
        );
        throw result.message;
      }
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);

export const patchWheelEntity = createAsyncThunk(
  "wheel/patch-wheel-entity",
  async (
    params: { data: WheelEntityRequest; id: number },
    thunkApi
  ): Promise<IWheelEntity | undefined> => {
    try {
      const response = await agent.patch(
        `${DEFAULT_URL_V2}prize/${params.id}`,
        { body: JSON.stringify(params.data) }
      );

      if (response.ok) {
        thunkApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        const result = await response.json();
        return result;
      }
      if (!response.ok) {
        const result = (await response.json()) as { message: string };
        thunkApi.dispatch(
          addNotification({ status: "error", text: result.message })
        );
        throw result.message;
      }
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);

export const getWheelEntity = createAsyncThunk(
  "wheel/get-wheel-entity",
  async (
    params: { id: number },
    thunkApi
  ): Promise<IWheelEntity | undefined> => {
    try {
      const response = await agent.get(`${DEFAULT_URL_V2}prize/${params.id}`);

      if (response.ok) {
        const result = await response.json();
        return result;
      }
      if (!response.ok) {
        const result = (await response.json()) as { message: string };
        thunkApi.dispatch(
          addNotification({ status: "error", text: result.message })
        );
        throw result.message;
      }
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);

export const postWheelEntityTranslate = createAsyncThunk(
  "wheel/post-wheel-entity-translate",
  async (params: { data: any; id: number }, thunkApi) => {
    try {
      const response = await agent.post(
        `${DEFAULT_URL_V2}prize/upload-translation/${params.id}`,
        {
          body: JSON.stringify(params.data),
        }
      );

      if (response.ok) {
        thunkApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        thunkApi.dispatch(getWheelEntity({ id: params.id }));
      }
      if (!response.ok) {
        const result = (await response.json()) as { message: string };
        thunkApi.dispatch(
          addNotification({ status: "error", text: result.message })
        );
        throw result.message;
      }
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);
